/**
 * [INPUT]: 无（仅读 window.plausible，由 index.html 的 Plausible 兼容脚本注入）
 * [OUTPUT]: 对外提供 trackEvent(name, props?) —— Plausible 自定义事件，类型安全 + 无脚本时静默
 * [POS]: apps/web 的分析事件层，被组件（结果页保存/分享/解锁诊断等）按用户动作调用
 * [PROTOCOL]: 变更时更新本头部，然后检查 ./CLAUDE.md
 */

export type PlausibleProps = Record<string, string | number | boolean>

export type PlausibleEventName =
  | 'Upload File Click'
  | 'Take Photo Click'
  | 'Camera Photo Captured'
  | 'File Dropped'
  | 'Image Pasted'
  | 'Camera Error'
  | 'Score Completed'
  | 'Score Rejected'
  | 'Retest Click'
  | 'Save Image'
  | 'Share Image'
  | 'Unlock AI Report'
  | 'AI Diagnosis Completed'
  | 'AI Diagnosis Failed'
  | 'Hero CTA Click'
  | 'FAQ Toggle'
  | (string & {})

declare global {
  interface Window {
    plausible?: (...args: unknown[]) => void
  }
}

/**
 * 触发一个 Plausible 自定义事件。脚本未加载（dev/广告拦截/被墙）时静默 no-op，
 * 且永不抛错——分析不得阻断产品主流程。
 */
export function trackEvent(name: PlausibleEventName, props?: PlausibleProps): void {
  if (typeof window === 'undefined') return
  const plausible = window.plausible
  if (typeof plausible !== 'function') return
  try {
    if (props) {
      plausible(name, { props })
    } else {
      plausible(name)
    }
  } catch {
    // swallow — analytics must never break product flow
  }
}